import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLang } from "@/contexts/LanguageContext";

export default function PageMeta() {
  const { pathname } = useLocation();
  const { t, lang } = useLang();

  useEffect(() => {
    const meta = t.meta;
    let entry = meta[pathname];
    if (!entry) {
      if (pathname.startsWith("/explorar/") || pathname.startsWith("/embarcacion/") || pathname.startsWith("/mis-embarcaciones/")) {
        entry = meta.boatDetail;
      } else {
        entry = meta["/"];
      }
    }
    document.title = entry[0];
    document.documentElement.lang = lang;
    let tag = document.querySelector('meta[name="description"]');
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("name", "description");
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", entry[1]);
  }, [pathname, t, lang]);

  return null;
}
